import { Cerca } from './Cerca';

export class Ruta {
    public idCompania: string;
    public idZona: number;
    public idRuta: number;
    public descripcion: string;

    public cerca: Cerca[];

}